import Grid from "@mui/material/Grid";
import ResultBoxes from "../features/ResultBoxes";
import Typography from "@mui/material/Typography";
import BackButton from "../components/base/ButtonBack";
import CalendarIcon from "../components/icons/CalendarIcon";

const SecondStep = () => {
  return (
    <>
      <Grid container mb={{ xs: 3, lg: 6 }} sx={{ justifyContent: { xs: 'center' }, rowGap: { xs: 2 } }}>
        <Grid md={6} sx={{ columnGap: { xs: 1 } }}>
          <Typography mb={{ xs: 0, lg: 1 }} variant="h1" color={'text.primary'}>Your Results</Typography>
          <Typography color={'text.secondary'} display={'flex'} alignItems={'center'} gap={1}>
            <CalendarIcon width='20px' height='20px'></CalendarIcon>
            {new Date().toLocaleString('en-us', { month: 'long', year: 'numeric', day: 'numeric' })}
          </Typography>
        </Grid>
        <Grid md={6} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <BackButton>Restart Survey</BackButton>
        </Grid>
      </Grid>
      <ResultBoxes></ResultBoxes>
    </>
  )
}

export default SecondStep;